import { Button } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { useRouter } from 'next/router';
import React from 'react';
import { PersonDto } from 'types/personen';
import { usePaginationLimit, useTranslation } from 'utils/hooks';


interface WeitereProfileProps 
{
  person: PersonDto;
}

const WeitereProfile: React.FC<WeitereProfileProps> = (props) =>
{
  const { person } = props;
  const { t } = useTranslation('profiles');
  const limit = usePaginationLimit();
  const router = useRouter();

  return (
      <ContentRow title={t('profiles:personen.weitere.label')}>
          <Button
            variant='transparent'
            onClick={() => 
            {
              const params = new URLSearchParams({
                term: person.hauptPersonenDaten.name,
                page: '1',
                limit: limit.toString(),
              });

              router.push(`/suche/p?${params.toString()}`);
            }}
          >

            {t('profiles:personen.weitere.text', {
              value: person.hauptPersonenDaten.name,
            })}

          </Button>
      </ContentRow>
  );
};

export default WeitereProfile;